import { Columns, Column } from "@aviary";
import type { LegalInformationData } from "@shared/types/fields";

import { BusinessTypeFields } from "../BusinessTypeFields/BusinessTypeFields";
import { BusinessTypeSelect } from "../BusinessTypeSelect/BusinessTypeSelect";

type BusinessInfoFieldsType = Pick<
  LegalInformationData,
  "accountType" | "businessName" | "employerId" | "classification"
>;

interface BusinessInfoFieldsTypeErrors {
  accountType: string[];
  businessName: string[];
  employerId: string[];
  classification: string[];
}

interface Props {
  values: BusinessInfoFieldsType;
  errors: BusinessInfoFieldsTypeErrors;
  onChange: (values: BusinessInfoFieldsType) => void;
  readonly?: boolean;
  setIsDirty?: (state: boolean) => void;
}

const BusinessInfoFields = ({ values, errors, onChange, readonly, setIsDirty }: Props) => {
  const onBusinessTypeChange = e => {
    if (setIsDirty) setIsDirty(true);
    onChange({
      ...values,
      accountType: e.target.value,
      businessName: "",
      employerId: "",
      classification: "",
    });
  };

  const onBusinessInfoChange = (newValues: BusinessInfoFieldsType) => {
    if (setIsDirty) setIsDirty(true);
    onChange(newValues);
  };

  const { accountType: accountTypeErrors, ...businessFieldsErrors } = errors ?? {};

  return (
    <Columns isMultiline>
      <Column columnWidth={6}>
        <BusinessTypeSelect
          value={values?.accountType ?? ""}
          errors={accountTypeErrors}
          onChange={onBusinessTypeChange}
          disabled={readonly}
        />
      </Column>

      <BusinessTypeFields
        legalInformationData={values as LegalInformationData}
        legalInformationErrors={{ fields: businessFieldsErrors }}
        handleSetLegalInformationData={onBusinessInfoChange}
        readonly={readonly}
      />
    </Columns>
  );
};

export {
  BusinessInfoFields,
  type Props,
  type BusinessInfoFieldsType,
  type BusinessInfoFieldsTypeErrors,
};
